export default __webpack_public_path__ + "static/capabilitiesImg2-30101e62200396bed6727fc87168b001.webp";